import React from 'react'
import { TableCell, TableRow, Skeleton } from '@mui/material'

export const LoadingSkeletonRows = ({ rows = 10, length = 1 }) => {
  return Array.from({ length: rows }).map((_, rowIndex) => (
    <TableRow key={`loading-row-${rowIndex}`}>
      {Array.from({ length }).map((_, colIndex) => (
        <TableCell key={`loading-cell-${rowIndex}-${colIndex}`}>
          <Skeleton variant='text' width='100%' height={24} />
        </TableCell>
      ))}
    </TableRow>
  ))
}
